import React, { useEffect, useState } from 'react';
import { supabase, fetchStoreSiteContent } from '../supabaseClient';
import { buildStoreSiteContentMap } from '../storeSiteContent';
import PublicSite from './PublicSite';

const StoreSite = ({ slug, page = 'home', isSignedIn = false }) => {
  const cacheKey = slug ? `ss_store_site_${slug}_v1` : null;

  const [contentMap, setContentMap] = useState(() => {
    if (!cacheKey) return buildStoreSiteContentMap();
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) return buildStoreSiteContentMap(JSON.parse(cached));
    } catch {}
    return buildStoreSiteContentMap();
  });

  const [storeName, setStoreName] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) { setLoading(false); return; }
    let active = true;

    supabase
      .from('restaurants')
      .select('id, name')
      .eq('slug', slug)
      .eq('lifecycle_status', 'active')
      .maybeSingle()
      .then(({ data: restaurant }) => {
        if (!active || !restaurant?.id) return null;
        if (restaurant.name) setStoreName(restaurant.name);
        return fetchStoreSiteContent(restaurant.id);
      })
      .then((rows) => {
        if (!active || !rows) return;
        const map = buildStoreSiteContentMap(rows);
        if (cacheKey) {
          try { localStorage.setItem(cacheKey, JSON.stringify(rows)); } catch {}
        }
        setContentMap(map);
      })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });

    return () => { active = false; };
  }, [slug, cacheKey]);

  if (loading) return null;

  return <PublicSite page={page} isSignedIn={isSignedIn} contentOverride={contentMap} storeName={storeName} />;
};

export default StoreSite;
